import { map} from "rxjs";
import { Injectable } from '@angular/core';

import { AuthService } from "@data/services/modules/auth/auth.service";
import { ApiClass } from "@data/class/api-class";
import { environment } from "@env/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiQuoterService extends ApiClass {
  user!: string
  id!: string

  constructor(
    private readonly authService: AuthService
  ) {
    super()
    this.path = 'quotations'
  }

  create(data: any) {
    return this.http.post(environment.apiUrl + 'quotations/create-hubspot', data)
  }

  getAmounts(data: any) {
    data.case = 'AMOUNTS'
    return this.http.post(environment.apiUrl + 'quotations/create-hubspot', data)
      .pipe(map((r) => r as { error: boolean, msg: string, data: any }))
  }
}
